import React, { useEffect, useState } from 'react';
import HeartRating from '../HeartRating';
import { useTranslations } from '../context/TranslationContext';
import fetchCustom from '../../wp_helpers/fetchCustom';
import Popover from '../Popover';
import './index.less';

const ApplicantHeartRating = ({ context, onUpdate }) => {
    const { _links } = context;
    const { t } = useTranslations();
    const [data, setData] = useState({
        heart_rating: 0,
        average_rating: 0,
        heart_rating_range: [],
        ratings_data: [],
    });
    const { heart_rating, average_rating, heart_rating_range, ratings_data } = data || {};
    const getRatingsUrl = _links?.get?.url || '';
    const deleteRatingsUrl = _links?.delete?.url || '';
    const postRatingsUrl = _links?.post?.url || ''; 

    const fetchRatings = async (signal) => {
        if (!getRatingsUrl) return;
        try {
            const response = await fetchCustom(getRatingsUrl, { signal });
            const data = await response.json() || {};
            setData({
                heart_rating: data?.heart_rating || 0,
                average_rating: data?.average_rating || 0,
                heart_rating_range: data?.heart_rating_range || [],
                ratings_data: data?.ratings_data || [],
            });
        } catch (error) {
            if (error.name === 'AbortError') {
                return;
            }
            console.error('Error fetching ratings:', error);
        }
    };

    useEffect(() => {
        const controller = new AbortController();
        fetchRatings(controller.signal);
        return () => controller.abort();
    }, [getRatingsUrl]);

    const onClickRatingHandler = async (rating) => {
        if (rating === heart_rating) {
            if (!deleteRatingsUrl) return;
            const url = deleteRatingsUrl;
            const response = await fetchCustom(url, {
                method: 'DELETE',
            });
            if (response.ok) {
                fetchRatings();
                onUpdate();
                notification(t('Your rating was deleted'), { type: 'success' });
            } else {
                notification(t('ajax_fail_notification'), { type: 'error' });
            }
            return
        }

        if (!postRatingsUrl) return;
        const url = postRatingsUrl.replace('{rating:int}', rating);
        const response = await fetchCustom(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.ok) {
            fetchRatings();
            onUpdate();
            notification(t('Your rating was saved'), { type: 'success' });
        } else {
            notification(t('ajax_fail_notification'), { type: 'error' });
        }
    };

    if(!getRatingsUrl) {
        return null;
    }
    
    return (
        <div className='applicant-heart-rating'>
            <HeartRating
                size='md'
                ratingRange={heart_rating_range}
                title={t('Your rating')}
                rating={heart_rating}
                onClick={onClickRatingHandler}
                tooltip={t('Heart rating reflects your personal evaluation. This rating stays consistent across all steps in the evaluation and can be updated anytime.')}
            />
            <HeartRating
                size='md'
                disabled
                ratingRange={heart_rating_range}
                title={t('Average rating')}
                rating={average_rating}
                tooltip={t('Average heart rating given by all evaluators. This is a combined rating from everyone who has rated the applicant.')}
            >
                <Popover title={ratings_data?.length} >
                    {ratings_data?.length > 0 ? ratings_data.map((rating) => (
                        <HeartRating
                            key={rating.user}
                            size='sm'
                            ratingRange={heart_rating_range}
                            title={rating.user}
                            rating={rating.rating}
                        />
                    )) : <span>{t('No ratings')}</span>}
                </Popover>
            </HeartRating>
        </div>
    );
};

export default ApplicantHeartRating;